import React from 'react'
import { roundWithLocale } from '@sketch/utils'
import { AttributeList } from '../Attribute'
import FullCopyAttribute from '../FullCopyAttribute'
import Header, { Title } from '../Header'
import Section from '../Section'
import Separator from '../Separator'
import { InspectorData } from 'modules/shares/Inspector/types'

const GridSettings = ({ grid }: { grid: InspectorData['grid'] }) => {
  if (!grid || !grid.isEnabled) {
    return null
  }

  const { size, thickGridTimes } = grid

  return (
    <>
      <Separator />
      <Section data-testid="inspector-sidebar-artboard-grid-settings">
        <Header
          copyValue={`Grid size: ${size}px, thick lines every: ${thickGridTimes} blocks`}
        >
          <Title>Grid Settings</Title>
        </Header>
        <Separator />
        <AttributeList>
          {size !== undefined ? (
            <FullCopyAttribute
              display="wide"
              label="Grid Size"
              copyValue={`${size}px`}
              value={`${roundWithLocale(size, 2)}px`}
            />
          ) : null}
          {thickGridTimes !== undefined ? (
            <FullCopyAttribute
              display="wide"
              label="Thick lines every N blocks"
              copyValue={`${thickGridTimes}px`}
              value={roundWithLocale(thickGridTimes, 2)}
            />
          ) : null}
        </AttributeList>
      </Section>
    </>
  )
}

export default GridSettings
